"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRStMxAuthUrl = void 0;
const url_utils_1 = require("./url.utils");
class XHRStMxAuthUrl {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        if (request.url.includes('mb-api-auth')) {
            if ((0, url_utils_1.isSSSEnvironment)()) {
                request.url = request.url.replace('mb-api-auth', 'st-api-auth');
            }
            else {
                request.url = request.url.replace(/^http.*\/mb-api-auth\//, `${(0, url_utils_1.getSTMXPrivateBaseHost)(request.url)}/st-api-poc-mex-sss/`);
            }
        }
        return Promise.resolve(request);
    }
}
exports.XHRStMxAuthUrl = XHRStMxAuthUrl;
//# sourceMappingURL=xhrStMxAuthUrl.js.map